import { AbstractControl, FormArray, ValidationErrors } from '@angular/forms';
import { assign, isArray, omit } from 'lodash';

export function atLeastOneSelectionValidator(
  FormArray: AbstractControl<any>
): ValidationErrors | null {
  if (!isArray(FormArray.value)) {
    throw new Error('Form Control is not an array.');
  }

  if (FormArray.value.length < 1) {
    const needSelection = { needSelection: true };
    FormArray.setErrors(
      FormArray.errors ? assign(FormArray.errors, needSelection) : needSelection
    );
    return needSelection;
  } else {
    FormArray.setErrors(
      FormArray.errors ? omit(FormArray.errors, ['needSelection']) : null
    );
    return null;
  }
}
